(function () {
  'use strict';

  angular.module('uwAgenda.settings.aiagent', [
    'uwAgenda.global'
  ]).config(['$stateProvider', AiAgentSettingsConfig]);

  function AiAgentSettingsConfig($stateProvider) {
    $stateProvider
      .state('Home.AiAgent', {
        url: 'AiAgent',
        templateUrl: '/app/settings/aiagent/templates/aiagent-settings.template.html',
        resolve: {
          deps: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load({
              name: 'uwAgenda aiagents',
              serie: true,
              insertBefore: '#ng_load_plugins_before',
              files: [
                '/assets/lib/lazy-loaded/profile.css',
                '/assets/lib/lazy-loaded/todo-2.min.css',
                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.css',

                '/assets/lib/lazy-loaded/todo-2.min.js',
                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.js',

                '/assets/lib/lazy-loaded/profile.min.js'
              ]
            });
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'settings' | translate}}"
        }
      })
      .state('Home.AiAgent.Transcriptions', {
        url: '/Transcriptions',
        templateUrl: '/app/settings/aiagent/templates/aiagent-transcriptions-view.template.html',
        controller: 'AiAgentTranscriptionsController',
        controllerAs: 'vm',
        params: {},
        resolve: {
          transcriptions: ['TranscriptionPaginationService', 'SharedAgendaService', function (TranscriptionPaginationService, SharedAgendaService) {
            TranscriptionPaginationService.data.userId = SharedAgendaService.currentUser().id;
            return TranscriptionPaginationService.search();
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'ai_agent_transcript' | translate}}"
        }
      });
  }
})();